module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"report.download":"Baixar relatório"},"en-US":{"report.download":"Export report"}}')
  delete Component.options._Ctor
}
